<template>
    <v-container fluid>
        <v-row
            align="start"
            no-gutters
            v-masonry
        >
            <!----=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-ACCISURE--=-=-=-=-=-=-=-=-=---=-=-=-=-=-=-=-=-=-->
            <v-col
                cols="12"
                justify="center"
                lg="6"
                md="12"
                v-if="
                    accessCrud.some((x) => x.e && x.e == 'Customer') &&
                    accessCrud.find((x) => x.e == 'Customer').r
                "
                xl="4"
            >
                <Accisure @hook:mounted="redrawMasonry" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Accisure from "../components/widgets/Accisure";
export default {
    name: "Dashboard",
    data: () => ({
        accessCrud: [],
        isAnyReports: true
        //
    }),
    created: async function() {
        this.accessCrud = await this.$store.dispatch(
            "authentication/getAccess"
        );
    },
    mounted: function() {
        this.$redrawVueMasonry();
    },
    components: {
        Accisure,
    },
    methods: {
        redrawMasonry() {
            this.$redrawVueMasonry();
        }
        //--------------------
    }
};
</script>

<style lang="stylus" scoped>
c-square-w = 55px;
c-ssquare-w = 85px;

/deep/.status-stat {
    width: c-ssquare-w;
    height: c-ssquare-w;
}

/deep/.ageing-stat {
    width: c-square-w;
    height: c-square-w;

    .header {
        position: absolute;
        left: 4px;
        top: 0px;
    }

    .stat {
        margin-top: 5px;
        line-height: c-square-w;
    }
}

/deep/.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

/deep/.theme--dark {
    .base-background {
        background: #121212;
    }
}

/*
/deep/.dashboard-card
    background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1))
*/
</style>
